import { LayoutTemplate } from "@/components/icons"

import { type TemplateInfo, TEMPLATES } from "./template-data"

type TemplatePickerProps = {
  onSelect: (template: TemplateInfo) => void
}

export function TemplatePicker({ onSelect }: TemplatePickerProps) {
  return (
    <div className="space-y-3">
      <p className="text-muted-foreground text-sm">
        Choose a template to start with. You can customize all fields after.
      </p>
      <div className="grid grid-cols-2 gap-2.5">
        {TEMPLATES.map((t) => (
          <button
            key={t.id}
            className="hover:border-foreground hover:bg-muted/50 focus-visible:ring-ring flex items-start gap-3 rounded-lg border p-3 text-left transition-colors focus-visible:ring-2 focus-visible:outline-none"
            type="button"
            onClick={() => onSelect(t)}
          >
            <LayoutTemplate className="text-foreground mt-0.5 size-4 shrink-0" />
            <div className="min-w-0">
              <div className="truncate text-sm font-medium">{t.name}</div>
              <div className="text-muted-foreground mt-0.5 text-xs">{t.painFocus}</div>
              <div className="text-muted-foreground text-xs">{t.solutionFocus}</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}
